import { call, put } from 'redux-saga/effects';
import message from '../../utils/message';
import * as api from '../../api';
import {
    getTestReportSuccess,
    getTestReportFailure,
    createTestReportSuccess,
    createTestReportFailure,
    getUserTestReportsSuccess,
    getUserTestReportsFailure,
    getLatestTestReportSuccess,
    getLatestTestReportFailure,
} from '../actions/testReportActionsHelper';

// Get test report by ID
export function* handleGetTestReport(action) {
    try {
        const { reportId } = action.payload;
        const response = yield call(api.getTestReportById, reportId);

        if (response.data.success) {
            yield put(getTestReportSuccess(response.data.data));
        } else {
            throw new Error(response.data.message || 'Failed to fetch test report');
        }
    } catch (error) {
        console.error('Get test report saga error:', error);
        yield put(getTestReportFailure(error.message));
        message.error('Failed to fetch test report');
    }
}

// Create new test report
export function* handleCreateTestReport(action) {
    try {
        const reportData = action.payload;
        const response = yield call(api.createTestReport, reportData);

        if (response.data.success) {
            yield put(createTestReportSuccess(response.data.data));
            message.success('Test report saved successfully');
        } else {
            throw new Error(response.data.message || 'Failed to create test report');
        }
    } catch (error) {
        console.error('Create test report saga error:', error);
        yield put(createTestReportFailure(error.message));
        message.error('Failed to save test report');
    }
}

// Get user test reports
export function* handleGetUserTestReports(action) {
    try {
        const { userId, page = 1, limit = 10, testType } = action.payload;
        const params = { page, limit };
        if (testType) {
            params.testType = testType;
        }

        const response = yield call(api.getTestReports, userId, params);

        if (response.data.success) {
            yield put(getUserTestReportsSuccess({
                reports: response.data.data,
                pagination: response.data.pagination
            }));
        } else {
            throw new Error(response.data.message || 'Failed to fetch user test reports');
        }
    } catch (error) {
        console.error('Get user test reports saga error:', error);
        yield put(getUserTestReportsFailure(error.message));
        message.error('Failed to fetch test reports');
    }
}

// Get latest test report for user
export function* handleGetLatestTestReport(action) {
    try {
        const { userId, testType } = action.payload;
        const response = yield call(api.getLatestTestReport, userId, testType);

        if (response.data.success) {
            yield put(getLatestTestReportSuccess(response.data.data));
        } else {
            throw new Error(response.data.message || 'Failed to fetch latest test report');
        }
    } catch (error) {
        console.error('Get latest test report saga error:', error);
        yield put(getLatestTestReportFailure(error.message));
        // Don't show error message as latest report might not exist
    }
}